import React, { useEffect } from 'react'
import MenuLayout from '../components/Layout/menuLayout'
import { setMenuDisplay } from '../redux/reducers/menu_reducer';
import { useAppDispatch } from '../redux/reduxHooks';
import CashBoxHistory from '../components/cashBoxHistory';
import { useParams } from "react-router-dom-v5-compat";


const CashBoxHistoryPage = (props) => {
  const  dispatch  = useAppDispatch()
  const { id } = useParams()

  useEffect(() => {
    dispatch(setMenuDisplay({
      menu: false
    }))
  }, [])
  return (
    <div>
      <MenuLayout/>
      <CashBoxHistory id={Number(id)}/>
    </div>
  )
}

export default CashBoxHistoryPage
